import Aihub from "./Aihub";

export default Aihub;
